import {Component} from '@lib/Component';

export class FormStep extends Component {
  _change(index: number) {
    const children = this.element
      ? [...this.element.querySelectorAll('.m-step_item')]
      : [];
    children.map((c) => {
      c.classList.remove('current');
    });
    children[index].classList.add('current');
  }

  input() {
    this._change(0);
  }

  confirm() {
    this._change(1);
  }

  thanks() {
    this._change(2);
  }
}
